<mat-form-field color="accent" floatLabel="never" *ngIf="expanded">
    <input [placeholder]="placeholder" type="text" [ngModel]="searchQuery" (ngModelChange)="searchQueryChange.emit($event)" matInput #input />
    <button class="clear-search" (click)="resetSearch()" mat-icon-button *ngIf="searchQuery">
        <fa-icon icon="times"></fa-icon>
    </button>
</mat-form-field>
<button app-round-button Inverted matTooltipPosition="left" [matTooltip]="expanded ? 'Ausblenden' : 'Suche'" (click)="toggleExpanded()">
    <fa-icon [icon]="expanded ? 'times' : 'search'"></fa-icon>
</button>
